import { ResponseFaqListGet, ResponseTopicListGet } from '../../../api';
import { FaqApiClients, IFaqApiClient } from './faq.api.client';

export interface IFaqApiService {
    getTopicList(): Promise<ResponseTopicListGet>;
    getFaqList(id: string): Promise<ResponseFaqListGet>;
}

export class FaqApiService implements IFaqApiService {
    private static instance: FaqApiService;
    private api: IFaqApiClient;

    private constructor(basePath: string) {
        this.api = FaqApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (FaqApiService.instance == null) {
            FaqApiService.instance = new FaqApiService(basePath);
        }
        return FaqApiService.instance;
    }

    async getTopicList(): Promise<ResponseTopicListGet> {
        return (await this.api.faq.getTopics()).data;
    }

    async getFaqList(id: string): Promise<ResponseFaqListGet> {
        return (await this.api.faq.getFaqs(id)).data;
    }
}
